export default __webpack_public_path__ + "static/media/5img.71b08c85.png";